<template>
  <b-modal
    id="modal-editer"
    size="xl"
    no-close-on-esc
    no-close-on-backdrop
    @ok="putParc"
    @cancel="onCancel"
    @close="onCancel"
    title="Éditer les données du parc"
    title-class="modal__title modal__title--edit"
  >
  <b-form class="parc-form pt-2 px-md-3">
    <!-- Nom du parc -->
    <b-form-group
      label-cols-lg="3"
      label="Nom usuel du parc"
      label-size="lg"
      label-class="fw-bold pt-0"
      class="mb-0"
    >
      <b-form-group
        id="input-group-nomUsuel"
        label="Nom usuel du parc éolien"
        label-for="input-nomUsuel"
        description="Veuillez saisir le nom du parc éolien tel qu'il figure dans les actes administratifs (arrêtés préfectoraux), le dossier de demande d'autorisation ou le dossier de déclaration."
      >
        <b-form-input
          id="input-nomUsuel"
          v-model="parc.nomUsuel"
          type="text"
          required
          placeholder="Saisir un texte"
          :state="validNomUsuel"
        ></b-form-input>
        <b-form-invalid-feedback :state="validNomUsuel">
          Le nom du parc est obligatoire
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form-group>

    <!-- raison sociale -->
    <b-form-group
      label-cols-lg="3"
      label="Raison sociale"
      label-size="lg"
      label-class="fw-bold pt-0"
      class="mb-0"
    >
      <b-form-group
        id="input-group-raisonSociale"
        label="Raison sociale"
        label-for="input-raisonSociale"
        description="La raison sociale est une donnée issue de GUN. En cas de modification à apporter, veuillez contacter GUN."
      >
        <b-form-input
          id="input-raisonSociale"
          v-model="parc.raisonSociale"
          type="text"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
      </b-form-group>

    <!-- siret -->
    <b-form-group
      label-cols-lg="3"
      label="SIRET"
      label-size="lg"
      label-class="fw-bold pt-0"
      class="mb-0"
    >
      <b-form-group
        id="input-group-siret"
        label="SIRET"
        label-for="input-siret"
        description="Le SIRET est une donnée issue de GUN. En cas de modification à apporter, veuillez contacter GUN."
      >
        <b-form-input
          id="input-siret"
          v-model="parc.siret"
          type="text"
          :disabled="true"
        ></b-form-input>
      </b-form-group>

      <div class="mt-1 mb-2">
        Diffusion de la raison sociale et du SIRET
      </div>
      <b-form-checkbox
        id="checkbox-rgpd"
        v-model="parc.rgpd"
        name="checkbox-rgpd"
        unchecked-value="false"
        class=" mb-4 rgpd-input"
      >
        <small class="text-muted"
        >Veuillez cocher la case si vous acceptez la diffusion publique de la raison sociale et du SIRET.</small
        >
      </b-form-checkbox>
    </b-form-group>

    <!-- Caractéristiques -->
    <b-form-group
      label-cols-lg="3"
      label="Caractéristiques"
      label-size="lg"
      label-class="fw-bold pt-0"
      class="mb-0"
    >
      <b-form-group
        id="input-group-nombreAerogenerateur"
        label="Nombre d'éoliennes"
        label-for="input-nombreAerogenerateur"
        description="Veuillez saisir le nombre d'éoliennes qui composent le parc éolien. En cas d’autorisation partielle, ne saisir que les éoliennes qui ont été autorisées."
      >
        <b-form-input
          id="input-nombreAerogenerateur"
          v-model.number="parc.nombreAerogenerateur"
          type="number"
          required
          placeholder="Saisir un nombre"
          min="0"
          :no-wheel="true"
          :state="validNombreAerogenerateur"
        ></b-form-input>
        <b-form-invalid-feedback :state="validNombreAerogenerateur">
          Le nombre d'éoliennes doit être positif
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="input-group-nombrePosteLivraison"
        label="Nombre de postes de livraison"
        label-for="input-nombrePosteLivraison"
        description="Veuillez saisir le nombre de poste(s) de livraison déclaré(s) / autorisé(s)."
      >
        <b-form-input
          id="input-nombrePosteLivraison"
          v-model.number="parc.nombrePosteLivraison"
          type="number"
          required
          placeholder="Saisir un nombre"
          min="0"
          :state="validNombrePosteLivraison"
        ></b-form-input>
        <b-form-invalid-feedback :state="validNombrePosteLivraison">
          Le nombre de poste de livraison doit être positif et supérieur ou égal au nombre de postes déja déclarés
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Communes -->
      <b-form-group
        id="input-group-communes"
        class="mb-2"
        label="Commune(s) d'installation"
        label-for="input-communes"
        description="Veuillez saisir le nom ou le code INSEE de(s) commune(s) d’implantation du parc éolien."
      >
        <b-form-input
          id="input-communes"
          type="text"
          placeholder="Saisir le nom ou le code INSEE d'une commune"
          v-model="communeSearch"
          :state="validNomCommune"
          v-click-outside="onClickOutsideInput"
          @keydown.esc="onClickOutsideInput"
          @update:model-value="getCommunesbyCriteria"
        ></b-form-input>
        <b-form-invalid-feedback :state="validNomCommune">
          La commune n'existe pas.
        </b-form-invalid-feedback>
        <div class="communes-list">
          <b-list-group class="communes-list__group">
            <b-list-group-item
              class="communes-list__item"
              v-for="(commune, index) in communes"
              :key="index"
              :value="commune"
              @click="addCommune(commune)"
            >
                    <span v-if="commune.nomCommuneMaj">
                      {{ commune.nomCommuneMaj }} ({{ commune.inseeCommune }})
                    </span>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-form-group>

      <div
        class="d-flex align-items-center"
        v-for="commune in parc.inventaireCommunes"
        :key="commune.id"
      >
        <b-button
          variant="outline-danger"
          size="sm"
          title="Supprimer la commune"
          class="communes-list__deleteBtn"
          v-on:click="removeCommune(commune)"
        >
          <i class="fa fa-trash"></i>
        </b-button>
        <span> {{ commune.nomCommune }} ({{ commune.codeInsee }}) </span>
      </div>
    </b-form-group>

    <div class="mt-4"></div>

    <!-- Dates d'autorisation -->
    <b-form-group
      v-show="selectedSituation === PARC_SITUATION.AUTORISATION"
      label-cols-lg="3"
      :label="PARC_SITUATION_LABEL[PARC_SITUATION.AUTORISATION]"
      label-size="lg"
      label-class="fw-bold pt-0"
      class="mb-0"
    >
      <b-form-group
        id="input-group-dateDepotDemandeAutorisation"
        label="Date de dépôt du dossier de demande d'autorisation auprès de la DREAL ou date du permis de construire pour les parcs éoliens qui bénéficient de l'antériorité"
        label-for="input-dateDepotDemandeAutorisation"
        description="Veuillez saisir la date à laquelle le dossier de demande d'autorisation a été déposé (jj/mm/aaaa)"
      ><b-form-input
        id="input-dateDepotDemandeAutorisation"
        v-model="parc.dateDepotDemandeAutorisation"
        type="date"
        :max="todayDate"
        reset-button
        placeholder="Saisir une date"
        :state="validDateDepotDemandeAutorisation"
      ></b-form-input>
        <b-form-invalid-feedback v-if="!isDateDepotDemandeAutorisationValid">
          La date ne doit pas être supérieure à la date du jour de la saisie
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="!validDateDepotDemandeAutorisation">
          {{ invalidDateDepotDemandeAutorisationMessage }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form-group>

    <!-- Dates déclaration -->
    <b-form-group
      v-if="isDeclaration"
      label-cols-lg="3"
      label="Déclaration"
      label-size="lg"
      label-class="fw-bold pt-0"
      class="mb-0"
    >
      <b-form-group
        class="position-relative"
        id="input-group-dateDelivranceRecipissePrefecture"
        label="Date de délivrance du récépissé de déclaration par la préfecture "
        label-for="input-dateDelivranceRecipissePrefecture"
        description="Veuillez saisir la date du récépissé de déclaration du projet (jj/mm/aaaa)."
      ><b-form-input
        id="input-dateDelivranceRecipissePrefecture"
        v-model="parc.dateDelivranceRecipissePrefecture"
        type="date"
        :max="todayDate"
        required
        placeholder="Saisir une date"
        :state="isDateDelivranceRecipissePrefectureValid"
      ></b-form-input>
        <b-form-invalid-feedback v-if="!isDateDelivranceRecipissePrefectureValid">
          La date ne doit pas être supérieure à la date du jour de la saisie
        </b-form-invalid-feedback>
        <ButtonClearDate
          :object="parc"
          name="dateDelivranceRecipissePrefecture"
          :date="parc.dateDelivranceRecipissePrefecture"
        />
      </b-form-group>
    </b-form-group>

    <!-- Construction -->
    <b-form-group
      label-cols-lg="3"
      label="Construction"
      label-size="lg"
      label-class="fw-bold pt-0"
      class="mb-0"
    >
      <b-form-group
        class="position-relative"
        id="input-group-dateDebutConstruction"
        label="Date de la déclaration d'ouverture du chantier de construction d'une ou plusieurs éolienne, ou du poste de livraison"
        label-for="input-dateDebutConstruction"
        description="Veuillez saisir la date de la déclaration d'ouverture du chantier de construction d'au moins une éolienne (si plusieurs dates, saisir la 1ère date par ordre chronologique) (jj/mm/aaaa)."
      >
        <b-form-input
          id="input-dateDebutConstruction"
          v-model="parc.dateDebutConstruction"
          type="date"
          :max="todayDate"
          required
          placeholder="Saisir une date"
          :state="validDateDebutConstruction"
        ></b-form-input>
        <ButtonClearDate
          :object="parc"
          name="dateDebutConstruction"
          :date="parc.dateDebutConstruction"
        />
        <b-form-invalid-feedback v-if="!isDateDebutConstructionValid">
          La date ne doit pas être supérieure à la date du jour de la saisie
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="!validDateDebutConstruction">
          Doit être inférieure aux dates de début de démantèlement<span
          v-if="parc.dateDebutDemantelement"
        >
                  ({{ $filters.formatDate(parc.dateDebutDemantelement) }})</span
        >
          et de cessation d'activité<span v-if="parc.dateCessationActivite">)</span
        >.
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form-group>

    <!-- Mise en service -->
    <b-form-group
      label-cols-lg="3"
      label="Mise en service"
      label-size="lg"
      label-class="fw-bold pt-0"
      class="mb-0"
    >
      <b-form-group
        class="position-relative"
        id="input-group-dateMiseEnService"
        label="Date de mise en service du parc"
        label-for="input-dateMiseEnService"
      >
        <b-form-input
          id="input-dateMiseEnService"
          v-model="parc.dateMiseEnService"
          type="date"
          :max="todayDate"
          required
          placeholder="Saisir une date"
          :state="validDateMiseEnService"
        ></b-form-input>
        <ButtonClearDate
          :object="parc"
          name="dateMiseEnService"
          :date="parc.dateMiseEnService"
        />
        <b-form-invalid-feedback v-if="!isDateMiseEnServiceValid">
          La date ne doit pas être supérieure à la date du jour de la saisie
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="!validDateMiseEnService">
          Doit être supérieure ou égale à la date de début de construction
          <span v-if="parc.dateDebutConstruction">
                  ({{ $filters.formatDate(parc.dateDebutConstruction) }})
                </span>.
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form-group>

    <!-- Début Démantèlement -->
    <b-form-group
      label-cols-lg="3"
      label="Démantèlement"
      label-size="lg"
      label-class="fw-bold pt-0"
      class="mb-0"
    >
      <b-form-group
        class="position-relative"
        id="input-group-dateDebutDemantelement"
        label="Date de la déclaration d’ouverture du chantier de démantèlement"
        label-for="input-dateDebutDemantelement"
        description="Veuillez saisir la date de déclaration de début des travaux de démantèlement (si plusieurs dates, saisir la 1ère date par ordre chronologique) (jj/mm/aaaa)."
      >
        <b-form-input
          id="input-dateDebutDemantelement"
          v-model="parc.dateDebutDemantelement"
          type="date"
          :max="todayDate"
          required
          placeholder="Saisir une date"
          :state="validDateDebutDemantelement"
        >
        </b-form-input>
        <ButtonClearDate
          :object="parc"
          name="dateDebutDemantelement"
          :date="parc.dateDebutDemantelement"
        />
        <b-form-invalid-feedback v-if="!isDateDebutDemantelementValid">
          La date ne doit pas être supérieure à la date du jour de la saisie
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="!validDateDebutDemantelement">
          Doit être inférieure à la date de cessation d'activité ({{
            $filters.formatDate(parc.dateCessationActivite)
          }})
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form-group>

    <!-- Situations Administratives -->
    <b-form-group
      label-cols-lg="3"
      label="Situation administrative"
      label-size="lg"
      label-class="fw-bold pt-0"
      class="mb-0"
    >
      <b-form-group
        id="input-group-situations"
        label="Le parc a-t-il fait l'objet d'une autorisation, d'un refus ou d'un rejet ?"
        label-for="input-situations"
        description="Veuillez sélectionner la situation administrative qui correspond au parc."
      >
        <b-form-select
          :options="situationsAdministratives"
          v-model="selectedSituation"
          @change="setSelectedSituation"
        ></b-form-select>
      </b-form-group>
      <hr class="my-4" v-show="selectedSituation !== ''" />
    </b-form-group>

    <b-form-group
      label-cols-lg="3"
      label="Dates administratives"
      label-size="lg"
      label-class="fw-bold pt-0"
      class="mb-0"
    >
      <!-- Avis de l'autorité environnementale -->
      <b-form-group
        id="input-group-dateDelivranceAvisAutoriteEnvironnementale"
        label="Date de délivrance de l'avis de l'autorité environnementale"
        label-for="input-dateDelivranceAvisAutoriteEnvironnementale"
        class="mb-4 position-relative"
        description="Veuillez saisir la date de l'avis de l'autorité environnementale (jj/mm/aaaa)."
        v-show="selectedSituation === 'autorisation' || selectedSituation === 'refus'"
      >
        <b-form-input
          id="input-dateDelivranceAvisAutoriteEnvironnementale"
          v-model="parc.dateDelivranceAvisAutoriteEnvironnementale"
          type="date"
          :max="todayDate"
          required
          placeholder="Saisir une date"
          :state="validDateDelivranceAvisAutoriteEnvironnementale"
        ></b-form-input>
        <ButtonClearDate
          :object="parc"
          name="dateDelivranceAvisAutoriteEnvironnementale"
          :date="parc.dateDelivranceAvisAutoriteEnvironnementale"
        />
        <b-form-invalid-feedback
          v-if="selectedSituation === 'refus' && !parc.dateDelivranceAvisAutoriteEnvironnementale"
        >
          Champ obligatoire
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="!isDateDelivranceAvisAutoriteEnvironnementaleValid">
          La date ne doit pas être supérieure à la date du jour de la saisie
        </b-form-invalid-feedback>
        <b-form-invalid-feedback
          v-else-if="!validDateDelivranceAvisAutoriteEnvironnementale"
        >
          Doit être supérieure à la date du dépôt de demande d'autorisation
          ({{ $filters.formatDate(parc.dateDepotDemandeAutorisation) }}) et
          inférieure ou égale à la date de délivrance d'autorisation ({{
            $filters.formatDate(parc.dateDelivranceAutorisation)
          }})
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Rejet -->
      <b-form-group
        id="input-group-dateDelivranceRejet"
        label="Date de l'arrêté de rejet"
        label-for="input-dateDelivranceRejet"
        class="mb-4 position-relative"
        description="Veuillez saisir la date de l'arrêté de rejet (jj/mm/aaaa)."
        v-show="selectedSituation === 'rejet'"
      >
        <b-form-input
          id="input-dateDelivranceRejet"
          v-model="parc.dateDelivranceRejet"
          type="date"
          :max="todayDate"
          required
          placeholder="Saisir une date"
          :state="validDateRejet"
        ></b-form-input>
        <ButtonClearDate
          :object="parc"
          name="dateDelivranceRejet"
          :date="parc.dateDelivranceRejet"
        />
        <b-form-invalid-feedback
          v-if="selectedSituation === 'rejet' && !parc.dateDelivranceRejet"
        >
          Champ obligatoire
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="!isDateDelivranceRejetValid">
          La date ne doit pas être supérieure à la date du jour de la saisie
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="!validDateRejet">
          Doit être supérieure à la date de dépôt de demande d'autorisation
          ({{ $filters.formatDate(parc.dateDepotDemandeAutorisation) }})
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Délivrance Autorisation -->
      <b-form-group
        id="input-group-dateDelivranceAutorisation"
        label="Date de délivrance de l'autorisation"
        label-for="input-dateDelivranceAutorisation"
        class="mb-4 position-relative"
        description="Veuillez saisir la date de délivrance d'autorisation (jj/mm/aaaa)."
        v-show="selectedSituation === 'autorisation'"
      >
        <b-form-input
          id="input-dateDelivranceAutorisation"
          v-model="parc.dateDelivranceAutorisation"
          type="date"
          :max="todayDate"
          required
          placeholder="Saisir une date"
          :state="validDateDelivranceAutorisation"
        ></b-form-input>
        <ButtonClearDate
          :object="parc"
          name="dateDelivranceAutorisation"
          :date="parc.dateDelivranceAutorisation"
        />
        <b-form-invalid-feedback v-if="!isDateDelivranceAutorisationValid">
          La date ne doit pas être supérieure à la date du jour de la saisie
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="!validDateDelivranceAutorisation">
          Doit être supérieure ou égale à la date de délivrance de l'avis de
          l'autorité environnementale ({{
            $filters.formatDate(parc.dateDelivranceAvisAutoriteEnvironnementale)
          }}) <span v-if="!isRenouvellementSubstantiel">et inférieure à la date de la déclaration d'ouverture du
          chantier de construction ({{
            $filters.formatDate(parc.dateDebutConstruction)
          }})</span>
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Refus -->
      <b-form-group
        id="input-group-dateDelivranceRefus"
        label="Date de l'arrêté de refus"
        label-for="input-dateDelivranceRefus"
        class="mb-4 position-relative"
        description="Veuillez saisir la date de l'arrêté de refus (jj/mm/aaaa)."
        v-show="selectedSituation === 'refus'"
      >
        <b-form-input
          id="input-dateDelivranceRefus"
          v-model="parc.dateDelivranceRefus"
          type="date"
          :max="todayDate"
          required
          placeholder="Saisir une date"
          :state="validDateRefus"
        ></b-form-input>
        <ButtonClearDate
          :object="parc"
          name="dateDelivranceRefus"
          :date="parc.dateDelivranceRefus"
        />
        <b-form-invalid-feedback v-if="!isDateDelivranceRefusValid">
          La date ne doit pas être supérieure à la date du jour de la saisie
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="!validDateRefus">
          Doit être supérieure ou égale à la date de délivrance de l'avis de
          l'autorité environnementale ({{
            $filters.formatDate(parc.dateDelivranceAvisAutoriteEnvironnementale)
          }})
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Cessation d'activité -->
      <b-form-group
        class="position-relative"
        id="input-group-dateCessationActivite"
        label="Date de cessation d'activité"
        label-for="input-dateCessationActivite"
        description="Veuillez saisir la date de la notification de la cessation d'activité de l'installation (jj/mm/aaaa)."
        v-show="selectedSituation === 'autorisation'"
      >
        <b-form-input
          id="input-dateCessationActivite"
          v-model="parc.dateCessationActivite"
          type="date"
          :max="todayDate"
          required
          placeholder="Indiquer la date de cessation d'activité du parc"
          :state="validDateCessationActivite"
        ></b-form-input>
        <ButtonClearDate
          :object="parc"
          name="dateCessationActivite"
          :date="parc.dateCessationActivite"
        />
        <b-form-invalid-feedback v-if="!isDateCessationActiviteValid">
          La date ne doit pas être supérieure à la date du jour de la saisie
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="!validDateCessationActivite">
          Doit être supérieure à la date du dépôt du dossier d'autorisation
          ({{ $filters.formatDate(parc.dateDepotDemandeAutorisation) }}) et à la
          date du début de démantèlement ({{
            $filters.formatDate(parc.dateDebutDemantelement)
          }}).
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form-group>

    <!-- Contentieux -->
    <!-- Cet input doit être masqué (potentiellement temporairement) -->
    <!-- https://gitlab.brgm.fr/brgm/bdeole/bdeole-dev/application/-/issues/114 -->
    <!-- <b-form-group
      label-cols-lg="3"
      label="Contentieux"
      label-size="lg"
      label-class="fw-bold pt-0"
      class="mb-0"
    >
      <div class="mt-1 mb-2">
        Recours en contentieux
      </div>
      <b-form-checkbox
        id="checkbox-contentieux"
        v-model="parc.contentieux"
        name="checkbox-contentieux"
        value="true"
        unchecked-value="false"
        class="contentieux-input"
      >
        <small class="text-muted"
          >Veuiller cocher la case si un recours en contentieux est en cours</small
        >
      </b-form-checkbox>
    </b-form-group> -->

  </b-form>
  <template #footer="{ ok, cancel }">
    <b-button
      variant="info"
      title="Enregistrer les modifications"
      @click="ok()"
      :disabled="disableSubitButtun || disableSubmitButtonDreal"
    >
      Valider
    </b-button>
    <b-button
      variant="default"
      title="Annuler les modifications"
      @click="cancel()"
    >
      Annuler
    </b-button>
  </template>
  </b-modal>
</template>
<script setup>
import {
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormSelect,
  BListGroup,
  BListGroupItem,
  BModal,
} from "bootstrap-vue-next";
import ButtonClearDate from "@/components/Buttons/ButtonClearDate.vue";
import {useReactiveStoreGetters} from "@/composables/useStore";
import {computed, onMounted, ref} from "vue";
import {collectiviteService} from "@/service/collectivite.service";
import {commonService} from "@/service/common.service";
import {useFilters} from "@/composables/useFilters";
import {parcService} from "@/service/parc.service";
import store from "@/store";
import {todayDate, isDateNotInFuture} from "@/util/date.util.js";
import { PARC_SITUATION, PARC_SITUATION_LABEL } from "../../util/constants";
const {formatDate} = useFilters()
const emit = defineEmits(['reload-parc'])
// Data
const communeSearch = ref('');
const validNomCommune = ref(null);
const invalidDateDepotDemandeAutorisationMessage = ref('');
const communes = ref([]);
const selectedSituation = ref("");
const situationsAdministratives = [
  { value: PARC_SITUATION.AUTORISATION, text: PARC_SITUATION_LABEL[PARC_SITUATION.AUTORISATION] },
  { value: PARC_SITUATION.REFUS, text: PARC_SITUATION_LABEL[PARC_SITUATION.REFUS] },
  { value: PARC_SITUATION.REJET, text: PARC_SITUATION_LABEL[PARC_SITUATION.REJET] }
];

// MapGetters from store
const {
  parc,
  isPosteLivraisonModificationValid,
  isRenouvellementSubstantiel,
  isDeclaration,
  isAutorisation,
  isRejet,
  isRefus,
} = useReactiveStoreGetters([
  'parc',
  'isPosteLivraisonModificationValid',
  'isRenouvellementSubstantiel',
  'isDeclaration',
  'isAutorisation',
  'isRejet',
  'isRefus',
]);

// Props
const {
  isPublishable,
  lexSatutSaisie,
  addNotification,
  setSelectedSituation,
} = defineProps({
  isPublishable: Boolean,
  lexSatutSaisie: {
    type: Array,
    required: true,
  },
  addNotification: {
    type: Function,
    required: true,
  },
  setSelectedSituation: {
    type: Function,
    required: true,
  },
});

// Methods
const putParc = () => {
  parc.value.dateDelivranceRefus = selectedSituation.value === PARC_SITUATION.REFUS ? parc.value.dateDelivranceRefus : null;
  setStatutSaisie();
  cleanDatesByParcStatus();

  parcService
    .putParc(parc.value)
    .then(response => {
      parcService.getParcById(parc.value.id).then(parcUpdated => {
        store.dispatch("saveParc", parcUpdated);
      });
      // Notification spécifique si la situation est "refus", "rejet" ou "cessation d'activité"
      if (
        selectedSituation.value === PARC_SITUATION.REFUS ||
        selectedSituation.value === PARC_SITUATION.REJET ||
        parc.value.dateCessationActivite != null
      ) {
        const statutLabel = parc.value.dateCessationActivite != null
          ? "Cessation d'activité"
          : PARC_SITUATION_LABEL[selectedSituation.value];
        store.dispatch("saveTextNotification", {
          notificationIcon: "ti-check",
          notificationType: "success",
          notificationTextMessage: `Le parc a été dépublié automatiquement suite au passage du statut à : ${statutLabel}.`
        });
      } else {
        addNotification(response);
      }
    })
    .catch(err => {
      console.log(err);
    });
};

const cleanDatesByParcStatus = () => {
  switch (selectedSituation.value) {
    case PARC_SITUATION.AUTORISATION:
      parc.value.dateDelivranceRejet = null;
      parc.value.dateDelivranceRefus = null;
      break;
    case PARC_SITUATION.REFUS:
      parc.value.dateDelivranceAutorisation = null;
      parc.value.dateDelivranceRejet = null;
      break;
    case PARC_SITUATION.REJET:
      parc.value.dateDelivranceRefus = null;
      parc.value.dateDelivranceAutorisation = null;
      break;
  }
}

const getStatutSaisieById = (id) => {
  return lexSatutSaisie.find(s => s.id === id);
};

const setStatutSaisie = () => {
  const statutBrouillon = getStatutSaisieById(1);
  const statutDepublie = getStatutSaisieById(3);

  // Si le parc est Refusé/Rejeté/En cessation d'activité, le statut devient "Dépublié"
  if (parc.value.dateDelivranceRejet != null || parc.value.dateDelivranceRefus != null || parc.value.dateCessationActivite != null) {
    parc.value.statutSaisie = statutDepublie;
  } else if (parc.value.statutSaisie == null || parc.value.statutSaisie?.id === 4) {
    // Si statut null ou "Saisie non démarrée", passer en "Brouillon"
    parc.value.statutSaisie = statutBrouillon;
  }
};

const onCancel = () => {
  console.log("on cancel");
  parcService
    .getParcUnlockById(parc.value.id)
    .then(data => {
      if (data) {
        parc.value.dateVerrou = data.dateVerrou;
        parc.value.mailVerrou = data.mailVerrou;
      }
      emit('reload-parc');
    })
    .catch(err => {
      console.log(err);
    });
};

const removeCommune = (commune) => {
  const communeIndexToRemove = parc.value.inventaireCommunes.findIndex(
    communeEL => {
      if (communeEL === commune) {
        return true;
      }
    }
  );
  parc.value.inventaireCommunes.splice(communeIndexToRemove, 1);
};

const addCommune = (commune) => {
  const communeToAdd = {
    nomCommune: commune.nomCommuneMaj,
    codeInsee: commune.inseeCommune,
    codeDepartement: commune.inseeDep,
    codeRegion: commune.inseeReg,
    dateSaisie: new Date()
  };

  const isCommunePresent = parc.value.inventaireCommunes.find(communeEL => {
    return communeEL.codeInsee === communeToAdd.codeInsee;
  });

  if (isCommunePresent === undefined) {
    parc.value.inventaireCommunes.push(communeToAdd);
    parc.value.inventaireCommunes.sort((a, b) => {
      return a.nomCommune > b.nomCommune ? 1 : -1;
    });
  }
};

const clearCommunes = () => {
    communes.value = [];
};
const clearSearchCommunes = () => {
  communeSearch.value = "";
};
const onClickOutsideInput = () => {
  clearCommunes();
  clearSearchCommunes();
  validNomCommune.value = null;
};
const formatInput = (input) => {
  return input
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replaceAll("-", " ");
};

const getCommunesbyCriteria = () => {
  console.log("before",communes.value);
  communes.value = [];
  console.log("after clean", communes.value);
  validNomCommune.value = null;
  collectiviteService
    .getCommunesbyCriteria(formatInput(communeSearch.value))
    .then(response => {
      if (response) {
        if (response.status === 200) {
          response.json().then(data => {
            communes.value = data;
            console.log("after response", communes.value);
          });
        } else if (response.status === 204) {
          validNomCommune.value = communeSearch === "" ? null : false;
        } else {
          commonService.handleUnsuccessfulResponse(response);
        }
      } else {
        commonService.handleNoResponse();
      }
    })
    .catch(err => {
      console.log(err);
    });
};

const setDefaultSelectedSituation = () => {
  if (isRejet.value) {
    selectedSituation.value = PARC_SITUATION.REJET;
  } else if (isRefus.value) {
    selectedSituation.value = PARC_SITUATION.REFUS;
  } else {
    selectedSituation.value = PARC_SITUATION.AUTORISATION;
  }
  setSelectedSituation({ target: { value: selectedSituation.value } });
};

onMounted(() => {
  setDefaultSelectedSituation();
})



const isDateDepotDemandeAutorisationValid = computed(() => isDateNotInFuture(parc.value.dateDepotDemandeAutorisation));
const isDateDelivranceRecipissePrefectureValid = computed(() => isDateNotInFuture(parc.value.dateDelivranceRecipissePrefecture));
const isDateDebutConstructionValid = computed(() => isDateNotInFuture(parc.value.dateDebutConstruction));
const isDateMiseEnServiceValid = computed(() => isDateNotInFuture(parc.value.dateMiseEnService));
const isDateDebutDemantelementValid = computed(() => isDateNotInFuture(parc.value.dateDebutDemantelement));
const isDateDelivranceAvisAutoriteEnvironnementaleValid = computed(() => isDateNotInFuture(parc.value.dateDelivranceAvisAutoriteEnvironnementale));
const isDateDelivranceRejetValid = computed(() => {console.log(parc.value.dateDelivranceRejet); return isDateNotInFuture(parc.value.dateDelivranceRejet)});
const isDateDelivranceAutorisationValid = computed(() => isDateNotInFuture(parc.value.dateDelivranceAutorisation));
const isDateDelivranceRefusValid = computed(() => isDateNotInFuture(parc.value.dateDelivranceRefus));
const isDateCessationActiviteValid = computed(() => isDateNotInFuture(parc.value.dateCessationActivite));

const validDateMiseEnService = computed(() => {
  if(isDateMiseEnServiceValid.value === false) {
    return false;
  }
  return parc.value.dateDebutConstruction && parc.value.dateMiseEnService && parc.value.dateMiseEnService >= parc.value.dateDebutConstruction;
});

const validNomUsuel = computed(() => {
  return parc.value.nomUsuel ? null : false;
});

const validNombreAerogenerateur = computed(() => {
  return parc.value.nombreAerogenerateur >= 0 ? null : false;
});

const validNombrePosteLivraison = computed(() => {
  return (parc.value.nombrePosteLivraison >= 0 && isPosteLivraisonModificationValid.value) ? null : false;
});


const validDateDepotDemandeAutorisation = computed(() => {
  if (!parc.value.dateDepotDemandeAutorisation) {
    invalidDateDepotDemandeAutorisationMessage.value = "La saisie de ce champ est obligatoire.";
    return false;
  } else if (isDateDepotDemandeAutorisationValid.value === false) {
    return false;
  } else if (!isRenouvellementSubstantiel.value) {
    // Récupération des champs dates sauf dateDepotDemandeAutorisation
    const dates = Object.entries(parc.value)
      .filter(([key, value]) => key.includes("date") && !["dateDepotDemandeAutorisation", "dateVerrou", "dateLastPublication"].includes(key) && value)
      .map(([key, value]) => ({ key, value }))
      .sort((a, b) => a.value - b.value);

    // Renvoie true si dateDepotDemandeAutorisation est inféreure à toutes les autres dates
    if (dates.length > 0) {
      invalidDateDepotDemandeAutorisationMessage.value= `Doit être inférieure au ${formatDate(dates[0].value)}.`;

      return parc.value.dateDepotDemandeAutorisation < dates[0].value;
    }
    return true;
  }
});

const validDateDebutConstruction = computed(()  => {
  if(isDateDebutConstructionValid.value === false) {
    return false;
  }
  if (
    !parc.value.dateDebutConstruction ||
    (parc.value.dateDebutConstruction &&
      !parc.value.dateDebutDemantelement &&
      !parc.value.dateCessationActivite)
  ) {
    return null;
  }
  return (
    (!parc.value.dateDebutDemantelement ||
      parc.value.dateDebutConstruction < parc.value.dateDebutDemantelement) &&
    (!parc.value.dateCessationActivite ||
      parc.value.dateDebutConstruction < parc.value.dateCessationActivite)
  );
});

const validDateDebutDemantelement = computed(() => {
  if(isDateDebutDemantelementValid.value === false){
    return false;
  }
  if (
    !parc.value.dateDebutDemantelement &&
    !parc.value.dateCessationActivite
  ) {
    return null;
  }
  return (
    !parc.value.dateCessationActivite ||
    parc.value.dateDebutDemantelement < parc.value.dateCessationActivite
  );
});

const disableSubitButtun = computed(() => {
  return (
    validNomUsuel.value === false ||
    validDateDepotDemandeAutorisation.value === false ||
    validDateDebutConstruction.value === false ||
    validDateMiseEnService.value === false ||
    validDateDebutDemantelement.value === false ||
    isPosteLivraisonModificationValid.value === false
  );
});

const validDateDelivranceAvisAutoriteEnvironnementale = computed(() => {
  if(isDateDelivranceAvisAutoriteEnvironnementaleValid.value === false){
    return false;
  }
  const { dateDelivranceAvisAutoriteEnvironnementale, dateDepotDemandeAutorisation, dateDelivranceAutorisation, dateDelivranceRefus } = parc.value;

  if (!dateDelivranceAvisAutoriteEnvironnementale && selectedSituation.value === PARC_SITUATION.REFUS) {
    return false;
  }

  if (
    !dateDelivranceAvisAutoriteEnvironnementale ||
    (dateDelivranceAvisAutoriteEnvironnementale &&
      !dateDepotDemandeAutorisation &&
      !dateDelivranceAutorisation) ||
    (dateDelivranceAvisAutoriteEnvironnementale &&
      !dateDepotDemandeAutorisation &&
      !dateDelivranceRefus)
  ) {
    return null;
  }
  return (
    (!dateDepotDemandeAutorisation ||
      dateDelivranceAvisAutoriteEnvironnementale >
      dateDepotDemandeAutorisation) &&
    (!dateDelivranceAutorisation ||
      dateDelivranceAvisAutoriteEnvironnementale <=
      dateDelivranceAutorisation) &&
    (!dateDelivranceRefus ||
      dateDelivranceAvisAutoriteEnvironnementale <=
      dateDelivranceRefus)
  );
});

const validDateRejet = computed(() => {
  if (isDateDelivranceRejetValid.value === false) {
    return false;
  }
  if (!parc.value.dateDelivranceRejet && selectedSituation.value === PARC_SITUATION.REJET) {
    return false;
  }
  if (
    !parc.value.dateDelivranceRejet ||
    !parc.value.dateDepotDemandeAutorisation
  ) {
    return null;
  }
  return (
    parc.value.dateDelivranceRejet > parc.value.dateDepotDemandeAutorisation
  );
});

const validDateRefus = computed(() => {
  if (isDateDelivranceRefusValid.value === false) {
    return false;
  }
  const { dateDelivranceRefus, dateDelivranceAvisAutoriteEnvironnementale } = parc.value;

  if (!dateDelivranceRefus && selectedSituation.value === PARC_SITUATION.REFUS) {
    return false;
  }

  if (!dateDelivranceRefus || !dateDelivranceAvisAutoriteEnvironnementale) {
    return null;
  }

  return dateDelivranceRefus > dateDelivranceAvisAutoriteEnvironnementale;
});

const validDateDelivranceAutorisation = computed(() => {
  if (isDateDelivranceAutorisationValid.value === false) {
    return false;
  }
  if (!isRenouvellementSubstantiel.value) {
    if (
      !parc.value.dateDelivranceAutorisation ||
      (parc.value.dateDelivranceAutorisation &&
        !parc.value.dateDebutConstruction &&
        !parc.value.dateDelivranceAvisAutoriteEnvironnementale)
    ) {
      return null;
    }
    return (
      (!parc.value.dateDebutConstruction ||
        parc.value.dateDelivranceAutorisation <
        parc.value.dateDebutConstruction) &&
      (!parc.value.dateDelivranceAvisAutoriteEnvironnementale ||
        parc.value.dateDelivranceAutorisation >=
        parc.value.dateDelivranceAvisAutoriteEnvironnementale)
    );
  } else {
    // Si les dates sont issues d'un renouvellement substantiel, on ne compare pas à la date du début de construction
    if (
      !parc.value.dateDelivranceAutorisation ||
      (parc.value.dateDelivranceAutorisation &&
        !parc.value.dateDelivranceAvisAutoriteEnvironnementale)
    ) {
      return null;
    }
    return (
      !parc.value.dateDelivranceAvisAutoriteEnvironnementale ||
      parc.value.dateDelivranceAutorisation >=
      parc.value.dateDelivranceAvisAutoriteEnvironnementale
    );
  }
});

const validDateCessationActivite = computed(() => {
  if (isDateCessationActiviteValid.value === false) {
    return false;
  }
  if (
    !parc.value.dateCessationActivite ||
    (parc.value.dateCessationActivite &&
      !parc.value.dateDebutDemantelement &&
      !parc.value.dateDelivranceAutorisation)
    ) {
    return null;
  }
  return (
    (!parc.value.dateDebutDemantelement ||
      parc.value.dateCessationActivite > parc.value.dateDebutDemantelement) &&
    (!parc.value.dateDelivranceAutorisation ||
      parc.value.dateCessationActivite >
      parc.value.dateDelivranceAutorisation)
  );
});

const disableSubmitButtonDreal = computed(() => {
  switch (selectedSituation.value) {
    case PARC_SITUATION.AUTORISATION:
      return (
        validDateDelivranceAvisAutoriteEnvironnementale.value === false ||
        validDateDelivranceAutorisation.value === false ||
        validDateCessationActivite.value === false
      );
    case PARC_SITUATION.REFUS:
      return (
        validDateDelivranceAvisAutoriteEnvironnementale.value === false ||
        validDateRefus.value === false
      );
    case PARC_SITUATION.REJET:
      return validDateRejet.value === false;
  }
});

</script>
